import React from 'react'
import Layout from "@/components/Layout/Layout";
import styles from './ErrorBoundary.module.scss'

type Props = {
  children: React.ReactNode
}
class ErrorBoundary extends React.Component<Props> {

  state: {
    error?: any
  }
  constructor(props: Props) {
    super(props)

    // Define a state variable to track whether is an error or not
    this.state = { error: undefined }
  }
  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI

    return { error }
  }
  componentDidCatch(error: any, errorInfo: any) {
    // You can use your own error logging service here
    console.error({ error, errorInfo })
  }
  render() {
    // Check if the error is thrown
    if (this.state.error) {
      // You can render any custom fallback UI
      return (
        <Layout>
          <h2>We've encountered an error...</h2>
          <p>
            If this issue persists, please contact us at&nbsp;
            <a href="mailto:edhrec@edhrec.com">edhrec@edhrec.com</a>. Please include the error
            message below.
          </p>
          <p className={styles.errorContainer}>
            <strong>{this.state.error.message}</strong><br/>
            {this.state.error.stack}
          </p>
        </Layout>
      )
    }

    // Return children components in case of no error

    return this.props.children
  }
}

export default ErrorBoundary
